var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { removeFrom } from '../removeFrom';
/**
 * this method creates an object composed of the own and inherited enumerable property paths of object that are not omitted.
 *
 * @param {object} obj
 * @param {(...string[] | string[][])} path
 * @return {*}  {object}
 *
 * @example
 * omit({ 'a': 1, 'b': '2', 'c': 3 }, ['a', 'c']);
 * // returns { 'b': '2' }
 *
 */
export var omit = function (obj) {
    var path = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        path[_i - 1] = arguments[_i];
    }
    var newObject = __assign({}, obj);
    path.flat().forEach(function (pathItem) {
        newObject = removeFrom(newObject, "" + pathItem);
    });
    return newObject;
};
//# sourceMappingURL=omit.js.map